import type { StoreId } from "@KassaroAB/shared/types/ids";
import { api, apiFetchFormData } from "../utils/api";
import type { ChangeRequestView } from "@KassaroAB/shared/types/changeRequest";
import type { ChatSession, ChatSessionMessage } from "@KassaroAB/shared/types/chatSession";
import { normalizeChangeRequestView, normalizeChangeRequestViewRequired } from "../utils/normalizeChangeRequestView";

export const getStoreChatSessions = (storeId: StoreId) =>
  api.get<ChatSession[]>(`stores/${storeId}/chatSessions`);

export const createStoreChatSession = (storeId: StoreId, message: string, files?: File[]) => {
  const body = new FormData();
  body.append("message", message);
  (files ?? []).forEach((f) => body.append("file", f));
  return apiFetchFormData(`stores/${storeId}/chatSessions`, { body }) as Promise<ChatSession>;
};

export const getStoreChatSessionMessages = (storeId: StoreId, chatSessionId: string) =>
  api.get<ChatSessionMessage[]>(`stores/${storeId}/chatSessions/${chatSessionId}/messages`);

export const getStoreChatSessionChangeRequest = (storeId: StoreId, chatSessionId: string) =>
  api
    .get<ChangeRequestView | null>(`stores/${storeId}/chatSessions/${chatSessionId}/changeRequest`)
    .then(normalizeChangeRequestView);

export const getStoreChatSessionChangeRequests = (storeId: StoreId, chatSessionId: string) =>
  api
    .get<ChangeRequestView[]>(`stores/${storeId}/chatSessions/${chatSessionId}/changeRequests`)
    .then((changeRequests) => changeRequests.map(normalizeChangeRequestViewRequired));

export const postApproveStoreChatSessionChangeRequest = (
  storeId: StoreId,
  chatSessionId: string,
) =>
  api
    .post<ChangeRequestView>(
      `stores/${storeId}/chatSessions/${chatSessionId}/changeRequest/approve`,
      {},
    )
    .then(normalizeChangeRequestViewRequired);

export const postStoreChatSessionMessage = (
  storeId: StoreId,
  chatSessionId: string,
  message: string,
  files?: File[],
) => {
  const body = new FormData();
  body.append("message", message);
  (files ?? []).forEach((f) => body.append("file", f));
  return apiFetchFormData(`stores/${storeId}/chatSessions/${chatSessionId}/messages`, { body }) as Promise<unknown>;
};
